(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oi-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oi-faq').forEach(function (faq) {
    faq.addEventListener('click', function (e) {
      var btn = e.target.closest('.oi-faq-q');
      if (!btn) return;
      var item = btn.closest('.oi-faq-item');
      var panel = item.querySelector('.oi-faq-a');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      faq.querySelectorAll('.oi-faq-q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      faq.querySelectorAll('.oi-faq-a').forEach(function (p) { p.classList.remove('is-open'); });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oi-trust-badges"] && !Shopify.designMode) return;
  try {
    
(function () {
  var c = document.getElementById('oi-tb-ptcl');
  if (!c) return;
  for (var i = 0; i < 18; i++) {
    var p = document.createElement('div');
    p.className = 'oi-tb-pt';
    var sz = Math.random() > 0.7 ? 2 : 1;
    p.style.cssText = [
      'left:'   + (Math.random() * 100) + '%',
      'bottom:0',
      'width:'  + sz + 'px',
      'height:' + sz + 'px',
      '--d:'    + (5 + Math.random() * 7) + 's',
      '--dl:'   + (-Math.random() * 10)   + 's',
      '--dx:'   + ((Math.random() - 0.5) * 50) + 'px',
    ].join(';');
    c.appendChild(p);
  }

  var grid = document.querySelector('.oi-trust-grid');
  if (!grid) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  grid.classList.add('oi-tb-anim-init');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        grid.classList.add('oi-tb-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  io.observe(grid);
})();

  } catch(e) { console.error(e); }
})();
})();
